import React from 'react'
import { useHistory } from 'react-router-dom'

import Header from './Header'
import Menu from './Menu'
import Content from './Content'
import ToasterContainer from 'components/Utils/Toaster/Container'
import Mousetrap from 'mousetrap'
import RoutesHelper from '../../helpers/RoutesHelper'
import { PROFILE } from './tabTypes'

function Settings({ tab = PROFILE.id, options = '' }) {
  const history = useHistory()
  React.useEffect(
    () => {
      const mousetrap = new Mousetrap()
      mousetrap.bind(['escape'], () => {
        history.replace(RoutesHelper.app())
      })
      return function onUnmount() {
        mousetrap.reset()
      }
    },
    [history]
  )

  return (
    <div className="slite-design-system">
      <ToasterContainer />
      <div className="flexbox">
        <Menu tab={tab} options={options} />
        <div
          className="flexbox flexbox-align-center flexbox-column width-full height-full-page overflow-hidden position-relative"
          style={{ minWidth: 600 }}
        >
          <Header returnTo={RoutesHelper.app()} tab={tab} options={options} />
          <Content tab={tab} options={options} />
        </div>
      </div>
    </div>
  )
}

export default Settings
